import React from "react";
import MassUploadPlanUploadModal from "../../components/modals/plans/MassUploadPlanUploadModal";
import { LoadingButton } from "@mui/lab";
import CurrentClientContext from "../../providers/CurrentClientProvider";
import { Box, Paper, Typography } from "@mui/material";

const OtherPlanTools = (props) => {
    const isV3 = props?.visualVariant === 'v3';
    const [displayMassUploadPlanModal, setDisplayMassUploadPlanModal] = React.useState(false);
    const client = CurrentClientContext.useClient();

    React.useEffect(() => {
		document.title = 'Retail ORBIT: Other Plan Tools'
	}, [])

    if (!client.client) {
        return null;
    }

    return (
        <Box className={isV3 ? 'v3-plan-page v3-other-plan-tools-page' : undefined}>
            <Typography variant="h5" className={isV3 ? 'v3-plan-page__heading' : undefined}>Other Plan Tools</Typography>
            <Paper elevation={isV3 ? 0 : 1} className={isV3 ? 'v3-plan-card' : undefined} sx={{ p: 3 }}>
                <Typography variant="h6" className={isV3 ? 'v3-plan-page__subheading' : undefined}>Plan Factor Import</Typography>
                <LoadingButton
                        onClick={() => setDisplayMassUploadPlanModal(true)}
                        variant="outlined"
                        fullWidth
                        sx={{ mt: 1 }}
                      >
                    Plan Factor Import
                </LoadingButton>
            </Paper>
            <MassUploadPlanUploadModal
                open={displayMassUploadPlanModal}
                onClose={() => setDisplayMassUploadPlanModal(false)}
                client={client.client}
            />
        </Box>
    );
};

export default OtherPlanTools;